import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import { orderBy, map } from 'lodash';
import moment from 'moment';
import { toast } from 'react-toastify';
import { Row2, Row1, Row3 } from '../../Reservations/ReservationRows';

import {
  getReservations,
  filterAllReservations
} from '../../../actions/reservationActions';

function ReservationsPage() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getReservations());
  }, []);

  const reservations = useSelector((state) =>
    orderBy(
      state.reservations,
      (reservation) => {
        return moment(reservation.reservationDate, 'DD.MM.YYYY').format(
          'YYYYMMDD'
        );
      },
      ['asc']
    )
  );

  const initialValues = {
    search: ''
  };
  const handleSubmit = (values) => {
    dispatch(filterAllReservations(values)).catch(() => {
      toast.error(
        'Chyba ve spojení se serverem. Prosím zkuste filtrovat znovu.'
      );
    });
  };
  const handleSearch = (e) => {
    if (e.target.value === '') {
      dispatch(getReservations());
    }
  };
  return (
    <>
      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        <Form>
          <div className="search">
            <Field
              id="searchInput"
              name="search"
              type="search"
              size="20"
              autoFocus="autofocus"
              className="search-box"
              onInput={handleSearch}
              title="Datum 2020-07-17"
            />
            <button type="submit">
              <i className="fas fa-search" />
            </button>
          </div>
        </Form>
      </Formik>
      {map(
        reservations,
        ({
          lotName,
          reservationDate,
          reservationId,
          firstName,
          place,
          lastName,
          timeFrom,
          timeTo,
          latitude,
          longitude,
          floor
        }) => (
          <div key={reservationId}>
            <h2 className="reservation-title">
              Rezervace místa {place} uživatele {firstName} {lastName}
            </h2>
            <div key={reservationId} className="card">
              <Row1
                lotName={lotName}
                reservationDate={reservationDate}
                reservationId={reservationId}
              />
              <div className="card__body">
                <Row2 timeFrom={timeFrom} timeTo={timeTo} />
                <Row3 latitude={latitude} longitude={longitude} floor={floor} />
              </div>
            </div>
          </div>
        )
      )}
    </>
  );
}

export default ReservationsPage;
